import uuid from 'uuid/v4';
import { normalize } from 'normalizr';

import * as notificationsApi from 'Root/api/notifications';

import { notificationsSchema } from './schema';
import * as types from './types';

const normalizeNotifications = data => normalize(
  data,
  Array.isArray(data)
    ? [notificationsSchema]
    : notificationsSchema,
).entities.notifications || {};

export function pushNotification(notification) {
  return {
    type: types.NOTIFICATION_PUSH,
    payload: normalizeNotifications({
      ...notification,
      type: 'push',
      id: uuid(),
    }),
  };
}

export function fetchNotificationsAction() {
  return {
    type: types.NOTIFICATION_FETCH,
    payload: async () => normalizeNotifications(await notificationsApi.fetchNotifications()),
  };
}

export function readNotificationsAction(notificationIds) {
  return {
    type: types.NOTIFICATION_READ,
    payload: notificationsApi.readNotifications(notificationIds),
  };
}

export function dismissNotification(notificationId) {
  return {
    type: types.NOTIFICATION_DISMISS,
    payload: { notificationId },
  };
}
